class ConferenciaNfeList {
    static get $inject() {
        return ['$scope', '$uibModal', 'gql', 'Nfes']
    }

    constructor(scope, modal, gql, Nfes) {
        this.apply = (fn) => scope.$apply(fn)
        this.modal = modal
        this.gql = gql
        this.Nfes = Nfes

        this.perPage = 20
    }

    $onChanges({ filter }) {
        if (filter && filter.currentValue) {
            this.currentPage = 1

            this.loadNfes()
        }
    }

    loadNfes(page = {}) {
        const query = gql`
            query ConferenciaNfes($filialId: Int!, $filter: NfeFilter!, $after: String, $before: String) {
                filial(id: $filialId) {
                    id
                    nfesPage(filter: $filter, after: $after, before: $before, limit: ${this.perPage}) {
                        after
                        before
                        nfes: entries {
                            ... on Nfe {
                                id
                                chave
                                numero
                                emissao
                                valor
                                emitente {
                                    id
                                    nome
                                    cpfCnpj
                                    municipio
                                    uf
                                }
                                icmsTributacao {
                                    id
                                    confiavel
                                }
                            }
                        }
                    }
                }
            }
        `

        this.loadingPromise = this.gql
            .query(query, { filialId: this.filial.id, filter: this.filter, ...page })
            .then(({ filial: { nfesPage } }) => {
                const { after, before, nfes } = nfesPage

                this.nfes = nfes
                this.nextPage = after
                this.previousPage = before
                this.currentPage = this.currentPage + (page.after ? 1 : page.before ? -1 : 0)

                if (!page.after && !page.before)
                    this.searchContext = new Date()
            })
            .finally(() => this.apply())
    }

    downloadXlsx() {
        const { emissaoExterna, ...filter } = this.filter

        filter.emitenteUfIsNot = this.filialUf

        this.Nfes.downloadXlsx(this.empresaId, filter)
    }

    openDetails(nfe) {
        const { id, cnpj, razaoSocial, estado } = this.filial

        this.modal.open({
            backdrop: 'static',
            size: 'lg',
            component: 'conferenciaNfeDetailsModal',
            resolve: {
                filial: () => ({ id, cnpj, razaoSocial, uf: estado }),
                nfe: () => nfe
            }
        })
    }
}

angular.module('eficienciaFiscalModule')
    .component('conferenciaNfeList', {
        controller: ConferenciaNfeList,
        bindings: {
            empresaId: '<',
            filial: '<',
            filter: '<'
        },
        template: `
        <loading promise="$ctrl.loadingPromise">
            <highlighted ng-show="$ctrl.nfes.length === 0">
                <main>Nenhuma informação encontrada.</main>
            </highlighted>

            <highlighted ng-show="$ctrl.nfes == undefined">
                <main>Preencha o filtro acima para realizar uma consulta.</main>
            </highlighted>

            <div ng-if="$ctrl.nfes.length > 0">
                <nfe-downloads promise="$ctrl.downloadPromise" xlsx="$ctrl.downloadXlsx()"></nfe-downloads>

                <cursor-paginator
                    per-page="$ctrl.perPage"
                    next-page="$ctrl.nextPage"
                    previous-page="$ctrl.previousPage"
                    current-page="$ctrl.currentPage"
                    current-page-size="$ctrl.nfes.length" 
                    on-change="$ctrl.loadNfes($page)"
                    search-context="$ctrl.searchContext">
                </cursor-paginator>

                <table class="table no-margin">
                    <thead>
                        <tr>
                            <th class="text-center" width="1">#</th>
                            <th>Dados da emissão</th>
                            <th>Dados do emitente</th>
                            <th class="text-center no-break">
                                <span>Status</span>
                            </th>
                            <th class="text-center">Opções</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr ng-repeat="nfe in $ctrl.nfes">
                            <td class="text-center-middle">
                                {{ $index + 1 + (($ctrl.currentPage - 1) * $ctrl.perPage) }}
                            </td>

                            <td class="text-middle">
                                {{ nfe.chave }}<br/>
                                N° {{nfe.numero}} <br/>
                                <small class="no-break">{{ nfe.emissao | date: 'medium' }}</small><br/>
                            </td>

                            <td class="text-middle">
                                {{ nfe.emitente.nome }}<br>
                                <small>
                                    {{ nfe.emitente.cpfCnpj.length == 14 ? 'CNPJ' : 'CPF' }}: 
                                    {{ nfe.emitente.cpfCnpj | cpfCnpj }}
                                </small><br/>
                                <small class="no-break">
                                    {{ nfe.emitente.municipio ? nfe.emitente.municipio + '/' : '' }}
                                    {{ nfe.emitente.uf }}
                                </small><br/>
                            </td>

                            <td class="text-center-middle">
                                <span class="status" ng-if="nfe.icmsTributacao && nfe.icmsTributacao.confiavel">
                                    <i class="fa fa-check fa-2x text-success"></i>
                                    Valores corretos
                                </span>

                                <span class="status" ng-if="nfe.icmsTributacao && nfe.icmsTributacao.confiavel === false">
                                    <i class="fa fa-exclamation-triangle fa-2x text-danger"></i>
                                    Valores divergentes
                                </span>

                                <span class="status" ng-if="!nfe.icmsTributacao">
                                    <i class="fa fa-clock-o fa-2x text-warning"></i>
                                    Aguardando lançamento
                                </span>
                            </td>

                            <td class="text-center-middle">
                                <button class="btn btn-link" ng-click="$ctrl.openDetails(nfe)" ng-disabled="!nfe.icmsTributacao">
                                    Visualizar
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <nfe-downloads promise="$ctrl.downloadPromise" xlsx="$ctrl.downloadXlsx()"></nfe-downloads>

                <cursor-paginator
                    per-page="$ctrl.perPage"
                    next-page="$ctrl.nextPage"
                    previous-page="$ctrl.previousPage"
                    current-page="$ctrl.currentPage"
                    current-page-size="$ctrl.nfes.length" 
                    on-change="$ctrl.loadNfes($page)">
                </cursor-paginator>
            </div>
        </loading>
        `
    })
